// extracted by mini-css-extract-plugin
module.exports = {"modal-notify":"modal-notify","modal-background":"modal-background","modal-content":"modal-content","icon":"icon","notify__title":"notify__title","notify-message":"notify-message"};